import * as React from 'react';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function MultiSelect(props) {
  const { label, options, value, handleChange } = props;

  return (
    <Autocomplete
      multiple
      id="title"
      options={options}
      disableCloseOnSelect
      getOptionLabel={(option) => option.name}
      value={value}
      isOptionEqualToValue={(option, value) => option.name === value.name}
      renderOption={(props, option, { selected }) => {
        const { key,...optionProps } = props;
        return (
          <li key={key} {...optionProps}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={selected}
            />
            {option.name}
          </li>
        );
      }}
      sx={{
        marginTop: '1rem'
      }}
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder="Option" />
      )}
      onChange={(e, values) => {
        handleChange(values)}
      }
    />
  );
}